export const contactsData = {
    email: 'great.gurdeep@gmail.com',
    phone: '+917015851087',
    address: 'House no-08, Prabhu Prem Puram East Block, Ambala Cantt, Haryana-133006',

    sheetAPI: 'https://sheetdb.io/api/v1/xvj9di3dytpdc'
}